import React, { useState } from "react";

function AddService() {
  const [title, setTitle] = useState("");
  const [icon, setIcon] = useState("");
  const [description, setDescription] = useState("");
  const [features, setFeatures] = useState([""]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const token = localStorage.getItem('token');
  const handleFeatureChange = (index, value) => {
    const updated = [...features];
    updated[index] = value;
    setFeatures(updated);
  };

  const addFeature = () => {
    setFeatures([...features, ""]);
  };

  const removeFeature = (index) => {
    setFeatures(features.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const res = await fetch(process.env.REACT_APP_API_URL + "/primedale_services", {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          title,
          icon,
          description,
          features: features.filter(f => f.trim() !== "")
        })
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.message || "Failed to save");

      setMessage("✅ Service saved successfully!");
      setTitle("");
      setIcon("");
      setDescription("");
      setFeatures([""]);
    } catch (err) {
      setMessage("❌ Failed to save service");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>

      <div className="container-xxl py-5">


        <div className="container">
          <div className="text-center mb-5">
            <h6 className="section-title bg-white text-center icon-color px-3">
              <span className="footer-color">Admin</span>
            </h6>
            <h1 className="mb-4">Add New Service</h1>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-8">
              <form onSubmit={handleSubmit} className="bg-light p-4 rounded">

                {/* Title */}
                <div className="mb-3">
                  <label className="form-label">Service Title</label>
                  <input
                    type="text"
                    className="form-control"
                    value={title}
                    onChange={e => setTitle(e.target.value)}
                    required
                  />
                </div>

                {/* Icon */}
                <div className="mb-3">
                  <label className="form-label">
                    Font Awesome Icon (e.g. fa-plane)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={icon}
                    onChange={e => setIcon(e.target.value)}
                    required
                  />
                </div>

                {/* Description */}
                <div className="mb-3">
                  <label className="form-label">Description</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                    required
                  />
                </div>

                {/* Features */}
                <div className="mb-3">
                  <label className="form-label">Service Features</label>

                  {features.map((feature, index) => (
                    <div key={index} className="d-flex mb-2">
                      <input
                        type="text"
                        className="form-control me-2"
                        value={feature}
                        onChange={e =>
                          handleFeatureChange(index, e.target.value)
                        }
                        required
                      />
                      {features.length > 1 && (
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={() => removeFeature(index)}
                        >
                          ✕
                        </button>
                      )}
                    </div>
                  ))}

                  <button
                    type="button"
                    className="btn btn-outline-primary mt-2"
                    onClick={addFeature}
                  >
                    + Add Feature
                  </button>
                </div>

                {/* Submit */}
                <button
                  type="submit"
                  className="btn icon-color py-3 px-5"
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save Service"}
                </button>

                {message && (
                  <p className="mt-3 fw-bold text-center">{message}</p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddService;
